import { Button, Card, Inline, NewTabIcon, Stack, styled } from 'canoe';
import React from 'react';
import { EXTENSION_LINK } from 'site-constants';

import { Stepper } from './components/Stepper';
import { WizardView } from './components/WizardView';

const Container = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
`;

interface DownloadExtensionProps {
  onSkip?: () => void;
  onGoBack: () => void;
}

export const DownloadExtension = ({ onSkip, onGoBack }: DownloadExtensionProps) => {
  return (
    <Card size="xl">
      <Stepper currentStep={3} />
      <WizardView
        title="Please install the Candu Chrome Extension"
        subTitle="The Candu Chrome Extension lets you create and edit content while viewing your product.
It will not make any changes to your website until you decide to publish those changes."
      >
        <Container>
          <Inline space="normal" align="baseline" mt="s">
            <Button appearance="text" inline onClick={onGoBack}>
              Previous
            </Button>
            <Stack space="xxs" justify="center">
              <Button
                variant="secondary"
                onClick={() => {
                  window.open(EXTENSION_LINK, '_blank');
                }}
              >
                <Inline align="center" space="xs">
                  Install Chrome Extension
                  <NewTabIcon color="White" size="s" />
                </Inline>
              </Button>
              {onSkip && (
                <Button appearance="text" variant="contrast" inline size="xsmall" onClick={onSkip}>
                  Skip (not recommended)
                </Button>
              )}
            </Stack>
          </Inline>
        </Container>
      </WizardView>
    </Card>
  );
};
